'use strict';

import { NgModule } from '@angular/core';
import { SubmitComponent } from './component';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports     : [
    BrowserModule,
  ],
  declarations: [SubmitComponent],
  exports     : [SubmitComponent]
})
export class LKSubmit {
}
